import React from 'react';
import { MModalFooterProps } from './MModalFooter.types';
import * as Styled from './MModalFooter.styles';
import { ALinkStandalone } from '../../atoms/ALinkStandalone';
import { MButton } from '../MButton';

export function MModalFooter({ aLinkStandalone, mButton, mButton2 }: MModalFooterProps) {
  return (
    <Styled.Wrapper data-component-name="m-web-ui-kit-MModalFooter" data-testid="web-ui-kit-MModalFooter">
      {aLinkStandalone?.text && aLinkStandalone && (
        <Styled.LinkWrapper>
          <ALinkStandalone {...aLinkStandalone} />
        </Styled.LinkWrapper>
      )}
      {mButton?.buttonText && mButton && (
        <Styled.ButtonWrapper>
          <MButton {...mButton} />
        </Styled.ButtonWrapper>
      )}
      {mButton2?.buttonText && mButton2 && (
        <Styled.ButtonWrapper>
          <MButton {...mButton2} />
        </Styled.ButtonWrapper>
      )}
    </Styled.Wrapper>
  );
}
